var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCurrencyConversion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1076_6830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "#11A811",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 41.0001C17 23.3269 31.3269 9 49 9C66.6731 9 81 23.3269 81 41.0001C81 58.6732 66.6731 73.0001 49 73.0001C31.3269 73.0001 17 58.6732 17 41.0001Z",
    fill: "url(#paint0_linear_1076_6830)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 8.5C66.9492 8.5 81.5 23.0508 81.5 41C81.5 58.9493 66.9493 73.5 49 73.5C31.0507 73.5 16.5 58.9493 16.5 41C16.5 23.0508 31.0508 8.5 49 8.5Z",
    stroke: "#BBF9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9995 28.1667C56.0699 28.1667 61.8333 33.9294 61.8335 40.9998C61.8335 48.0703 56.07 53.8337 48.9995 53.8337C41.9291 53.8336 36.1665 48.0702 36.1665 40.9998C36.1667 33.9295 41.9293 28.1669 48.9995 28.1667ZM55.7271 36.1667C55.1814 35.6211 54.306 35.5867 53.7192 36.0642L53.606 36.1667L47.106 42.6658L44.3931 39.9529C43.8474 39.4076 42.9728 39.3739 42.3862 39.8513L42.2729 39.9529C41.7274 40.4985 41.693 41.374 42.1704 41.9607L42.2729 42.074L46.0464 45.8474C46.3257 46.1266 46.7063 46.2869 47.1069 46.2869C47.4574 46.2868 47.7919 46.1638 48.0571 45.946L48.1665 45.8474L55.7329 38.281C56.2679 37.7274 56.3088 36.8675 55.8296 36.28L55.7271 36.1667Z",
    fill: "#DCFDDB",
    stroke: "#F7FEF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1076_6830",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 16,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1076_6830"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1076_6830"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1076_6830"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.976471 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1076_6830",
    result: "effect2_dropShadow_1076_6830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1076_6830",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1076_6830",
    x1: 17,
    y1: 9,
    x2: 81.0001,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#1DCB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#46E345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCurrencyConversion);
export default __webpack_public_path__ + "static/media/SuccessCurrencyConversion.f5cf4804902541acef04059b7ab120f4.svg";
export { ForwardRef as ReactComponent };